import { v4 as uuidv4 } from 'uuid';

const STORAGE_KEY = 'st_chat_anon_id';

// The browser's half of the chat identity. Rails HMACs it with a server secret to mint the value
// Dify stores, so this must stay random — anything enumerable would expose conversation history.
export const getAnonId = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return stored;

    const anonId = uuidv4();
    localStorage.setItem(STORAGE_KEY, anonId);
    return anonId;
  } catch {
    // Private mode or blocked storage: a per-page-load identity still works, it just does not persist.
    return uuidv4();
  }
};

// Called on sign-out so the next user on this browser starts a fresh conversation, not the
// previous user's transcript.
export const clearAnonId = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Private mode or blocked storage: nothing was persisted, so there is nothing to clear.
  }
};
